import React from "react";
import CitiesListState from "../components/cities-list-state";
import LayoutDemolition from "../components/layout-demolition";
import ZipFinderState from "../components/zip-finder-state";

const STATEPAGEDEMOLITION = ({ pageContext }) => 
{
	const code = pageContext.code;
    const codes = pageContext.codes.length > 0 ? pageContext.codes : [];
    const state = pageContext.state;
	const env = pageContext.env;	
	const cities = pageContext.cities.length > 0 ? pageContext.cities : [];

	const seo_desc = pageContext.seo_desc;
    const seo = 
    {
        url: pageContext.url,
        env: env,
        code: code,
        page: 'state',
		state: state,
        seo_desc: seo_desc
    }

    const pickTitle = () => {
        let title = "Find {state} {code} Contractors";
        codes.map(element => {
            if (code === element.code) {
                let name = element.name === 'Demolition Contractors' ? 'Demolition' : element.name;
                title = title.replace('{code}', name);
            }
            return true
        })
        if (state !== undefined) {
            title = title.replace('{state}', state.name);
        }
        return title
    }

    const pickText = () => {
        let text = "We'll introduce you to professional {code} contractors ready to complete your project";
        codes.map(element => {
            if (code === element.code) {
                text = text.replace('{code}', element.name.toLowerCase());
            }

            return true;
        })

        return text;
    }

	return (
		<LayoutDemolition seo={seo} env={env} code={code} >

			<ZipFinderState
				id = 'home-zip-code'
				code = {code}						
				button = "Find Pros"
				bottomtext = "America's #1 Source for Local Demolition Experts"
				state = {pageContext.state}
                url = {pageContext.url}
                title = {pickTitle()}
                text = {pickText()}
                codes = {codes}
				env = {env}
				finderopenmodal = {true}
				/> 

			<CitiesListState
                cities = {cities}
				code = {code}
                state = {state}
                codes = {codes}
                env ={env} 
			/>
  
        </LayoutDemolition>
	)
};

export default STATEPAGEDEMOLITION;